const QUESTION_TYPE_LABELS_MAP = new Map([
  ['grade', 'Question notation'],
  ['selection', 'Question choix unique'],
  ['selection_multi', 'Question choix multiples'],
  ['comment', 'Question commentaire'],
  ['numeric', 'Question numérique'],
  ['photos', 'Question photo'],
  ['signature', 'Question signature'],
  ['variable', 'Question variable'],
  ['plan', 'Question plan']
])

const DATETIME_TYPE_LABELS = new Map([
  ['date_and_time', 'Question date / heure'],
  ['only_date', 'Question date'],
  ['only_time', 'Question heure']
])

export const getQuestionTypeLabel = question => {
  if (question.context === 'datetime')
    return DATETIME_TYPE_LABELS.get(question.datetime_format) || DATETIME_TYPE_LABELS.get('date_and_time')

  return QUESTION_TYPE_LABELS_MAP.get(question.context)
}

const CONTENT_TYPE_LABELS_MAP = new Map([
  ['title', 'Titre'],
  ['picture', 'Image'],
  ['pdf', 'PDF'],
  ['description', 'Description'],
  ['content_variable', 'Variable']
])

export const getContentTypeLabel = question => CONTENT_TYPE_LABELS_MAP.get(question.context)

export const DECORATIVE_CONTEXTS = ['title', 'picture', 'description', 'pdf', 'content_variable']
